package com.example.positionahead.ui.components

import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.example.positionahead.domain.CsvImportTemplate
import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

@Composable
actual fun DownloadCsvTemplateButton(
    modifier: Modifier,
    enabled: Boolean,
) {
    OutlinedButton(
        onClick = { downloadTemplateCsv() },
        modifier = modifier,
        enabled = enabled,
    ) {
        Text("Download template CSV")
    }
}

private fun downloadTemplateCsv() {
    val blob = Blob(
        arrayOf(CsvImportTemplate.content),
        BlobPropertyBag(type = "text/csv"),
    )
    val url = URL.createObjectURL(blob)
    val anchor = document.createElement("a") as HTMLAnchorElement
    anchor.href = url
    anchor.download = CsvImportTemplate.FILE_NAME
    document.body?.appendChild(anchor)
    anchor.click()
    document.body?.removeChild(anchor)
    URL.revokeObjectURL(url)
}
